<template functional>
    <v-alert
        color="error"
        outlined
    >
        {{$options.methods.getTranslatedString()}}
    </v-alert>
</template>

<script>
import i18n from '@/i18n';
import FieldMixin from './field-mixin.vue';
export default {
    mixins: [FieldMixin],
    methods: {
        getTranslatedString(){
            return i18n.t('instance.data_model.form_editor.fields_types.file_field.error')
        }
    }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/FormEditor/FieldsTypes/file-field.vue